export const BREADCRUMB_FILTER_KEYS = new Set([
    "category",
    "view",
    "inserts",
    "metal",
    "sex",
]);
